import { getSiteUrl, getWebSiteName, reactImageUrl } from '@/lib/GetBaseUrl'
import { _categoryImg_ } from '@/lib/ImagePath'

export const _projectName_ = getWebSiteName()
export const _headTitle_ = 'Your Destination for Quality Products'
export const _headDescription_ =
  'Discover a wide range of high-quality products at ${getWebSiteName()}. From electronics to fashion, we have everything you need!'
export const _headKeywords_ = `${getWebSiteName()}, online shopping, electronics, fashion, home appliances`
export const _ogDescription_ = `Explore a diverse collection of top-notch products at ${getWebSiteName()}`
export const _ogUrl_ = getSiteUrl()
export const _ogLogo_ = `${reactImageUrl}${_categoryImg_}logo.jpg`
